import Api from './Api'
import axios from 'axios'

let cancelDataRequest = null

class ProbeDataService {
    getAll = async params => {
        if (cancelDataRequest) {
            cancelDataRequest()
        }
        const CancelToken = axios.CancelToken
        const response = await Api().get('probe', {
            params: params,
            cancelToken: new CancelToken(c => {
                cancelDataRequest = c
            }),
        })
        cancelDataRequest = null
        return response
    }

    get = id => {
        return Api().get(`probe/${id}`)
    }

    update = activeProbe => {
        return Api().put(`probe/${activeProbe.id}`, activeProbe)
    }

    updateSensor = (activeProbeId, sensor) => {
        return Api().put(`probe/${activeProbeId}/sensor/${sensor.id}`, sensor)
    }

    createProbeLocation = (activeProbeId, data) => {
        return Api().post(`probe/${activeProbeId}/location`, data)
    }

    duplicateProbeLocation = async (probeId, locationId) => {
        return await Api().post(`probe/${probeId}/location/${locationId}`)
    }

    updateProbeLocation = (probeId, locationId, data) => {
        const userIds = data.users.map(u => u.id)
        return Api().put(`probe/${probeId}/location/${locationId}`, {
            userIds,
            locationId,
            seasonId: data.season_id,
            alias: data.alias,
            location_company_id: data.location_company_id,
            end_date: data.end_date,
            start_date: data.start_date,
            culture_id: data.culture_id,
            field_id: data.field_id,
            tillage_method_id: data.tillage_method_id,
            soil_type_id: data.soil_type_id,
            sector_id: data.sector_id,
            client_nr: data.client_nr,
        })
    }
    removeProbeLocation = async (probeId, locationId) => {
        return await Api().delete(`probe/${probeId}/location/${locationId}`)
    }
    recalculateNo3 = async (probeId, locationId) => {
        return await Api().patch(`probe/${probeId}/location/${locationId}/recalculate-no3`)
    }

    getProbeSensorMeasurements = async (probeId, sensorId, date) => {
        return await Api().get(`probe/${probeId}/sensor/${sensorId}/measurement`, {
            params: { date },
        })
    }

    deleteProbeSensorMeasurements = async (probeId, sensorId, measurements, deleteMeasurements) => {
        return await Api().post(`probe/${probeId}/sensor/${sensorId}/measurement`, {
            measurements,
            delete_measurements: deleteMeasurements,
        })
    }

    getLocationCompanies = async () => {
        return await Api().get('company')
    }

    updateProbePercoMeasurements = async (probeId, data) => {
        return await Api().post(`probe/${probeId}/perco`, data)
    }

    addProbeRegion = async (probeId, data) => {
        return await Api().post(`probe/${probeId}/region`, data)
    }

    mergeStations = async (stationId, data) => {
        return await Api().post(`station/${stationId}/merge`, data)
    }

    updateProbeUseForMapLayers = async (probeId, data) => {
        return await Api().put(`probe/${probeId}/toggle-use-for-map-layers`, data)
    }

    getSeasons = async () => {
        return await Api().get('season')
    }

    getTillageMethods = async () => {
        return await Api().get('tillage-methods')
    }

    getSectors = async () => {
        return await Api().get('sectors')
    }

    getProbeStateHistory = async (id, params) => {
        return await Api().get(`probe/${id}/state-history`, { params })
    }

    deleteProbeState = async stateId => {
        return await Api().delete(`station-state/${stateId}`)
    }
}

export default new ProbeDataService()
